export const parseHex = (hex: string, delta: number) => {
  return Math.min(255, Math.max(0, parseInt(hex, 16) + delta));
};

export const hexToRgb = (hexCode: string, alpha: number, delta: number = 0): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexCode);

  if (result) {
    const r = parseHex(result[1], delta);
    const g = parseHex(result[2], delta);
    const b = parseHex(result[3], delta);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return 'rgba(0,0,0,1)';
};

export const isWhite = (str?: string | null) => {
  if (!str) return true;

  // fiddle this value to set stricter rules for what is white.
  const whiteLimit = 200;

  const r = parseInt(`0x${str.substring(1, 3)}`, 10);
  const g = parseInt(`0x${str.substring(3, 5)}`, 10);
  const b = parseInt(`0x${str.substring(5, 7)}`, 10);

  return !(r < whiteLimit || b < whiteLimit || g < whiteLimit);
};
